document.addEventListener('DOMContentLoaded', () => {
  [...document.querySelectorAll('.js-carousel')].map((elt) =>
    new Carousel(elt)
  );
});

class Carousel { 
  constructor(carousel) {
    this.carousel = carousel;

    this.flickity = new Flickity(carousel, {
      draggable: true,
      wrapAround: true,
      pageDots: false,
      cellAlign: 'center',
      imagesLoaded: true
    });

    window.onload = function(){
    }

  }
}